"use strict";

var _interopRequireWildcard = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array-buffer.detached.js");
require("core-js/modules/es.array-buffer.transfer.js");
require("core-js/modules/es.array-buffer.transfer-to-fixed-length.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.typed-array.at.js");
require("core-js/modules/es.typed-array.find-last.js");
require("core-js/modules/es.typed-array.find-last-index.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.to-reversed.js");
require("core-js/modules/es.typed-array.to-sorted.js");
require("core-js/modules/es.typed-array.with.js");
require("core-js/modules/es.uint8-array.set-from-base64.js");
require("core-js/modules/es.uint8-array.set-from-hex.js");
require("core-js/modules/es.uint8-array.to-base64.js");
require("core-js/modules/es.uint8-array.to-hex.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var XLSX = _interopRequireWildcard(require("xlsx"));
var _ledgers = require("@/api/ledgers");
const PAYMENT_TYPES = ['Cash in Bank', 'Cheque', 'Net Banking'];
const NET_BANKING_MODES = ['RTGS', 'NEFT', 'IMPS'];
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.rows = [];
    this.uploadingAll = false;
    this.columns = [{
      name: 'dealerId',
      mandatory: true,
      description: 'System ID of the dealer (matches the dealer).',
      example: '1024'
    }, {
      name: 'dealerName',
      mandatory: false,
      description: 'For reference only, not used for matching.',
      example: 'ABC Electricals'
    }, {
      name: 'amount',
      mandatory: true,
      description: 'Positive number received from the dealer.',
      example: '25000'
    }, {
      name: 'paymentDate',
      mandatory: true,
      description: 'Date of payment. Text in DD/MM/YYYY.',
      example: '06/01/2026'
    }, {
      name: 'paymentType',
      mandatory: true,
      description: 'One of: Cash in Bank, Cheque, Net Banking.',
      example: 'Net Banking'
    }, {
      name: 'paymentMode',
      mandatory: false,
      description: 'Mandatory only for Net Banking: RTGS, NEFT or IMPS.',
      example: 'NEFT'
    }, {
      name: 'transactionReference',
      mandatory: true,
      description: 'UTR / cheque number / deposit slip reference.',
      example: 'UTIB2026010612345'
    }, {
      name: 'bank',
      mandatory: false,
      description: 'Bank account the payment was received in.',
      example: 'KOTAK MAHINDRA BANK (CA- 5746105231)'
    }, {
      name: 'narration',
      mandatory: false,
      description: 'Comments saved against the payment.',
      example: 'Against invoice INV/25-26/101'
    }, {
      name: 'createdBy',
      mandatory: true,
      description: 'ID of the admin who received/entered the payment.',
      example: '12'
    }];
  }
  get requiredColumns() {
    return this.columns.filter(c => c.mandatory).map(c => c.name);
  }
  get uploadableRows() {
    return this.rows.filter(r => this.canUpload(r));
  }
  get pendingCount() {
    return this.rows.filter(r => r.__status === 'pending').length;
  }
  get successCount() {
    return this.rows.filter(r => r.__status === 'success').length;
  }
  get failedCount() {
    return this.rows.filter(r => ['error', 'invalid'].includes(r.__status)).length;
  }
  canUpload(row) {
    return ['pending', 'error'].includes(row.__status);
  }
  pickFile() {
    const upload = this.$refs.uploadRef;
    const input = upload && upload.$el.querySelector('input[type="file"]');
    if (input) input.click();
  }
  handleExceed() {
    this.$message.warning('Only one file can be uploaded at a time.');
  }
  downloadTemplate() {
    const headers = this.columns.map(c => c.name);
    const sample = this.columns.map(c => c.example);
    const ws = XLSX.utils.aoa_to_sheet([headers, sample]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Payments');
    XLSX.writeFile(wb, 'bulk-payment-upload-template.xlsx');
  }
  handleFileChange(file) {
    const reader = new FileReader();
    reader.onload = e => {
      try {
        const workbook = XLSX.read(new Uint8Array(e.target.result), {
          type: 'array',
          cellDates: true
        });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet, {
          defval: null,
          raw: true
        });
        this.loadRows(json);
      } catch (error) {
        this.$message.error('Error reading Excel file. Please try again.');
      } finally {
        this.$refs.uploadRef.clearFiles();
      }
    };
    reader.onerror = () => this.$message.error('Error reading file.');
    reader.readAsArrayBuffer(file.raw);
  }
  loadRows(json) {
    if (!json.length) {
      this.$message.error('Excel file is empty!');
      return;
    }
    const actual = Object.keys(json[0]);
    const missing = this.requiredColumns.filter(c => !actual.includes(c));
    if (missing.length) {
      this.$message.error(`Missing required columns: ${missing.join(', ')}`);
      return;
    }
    this.rows = json.map(row => {
      const error = this.validateRow(row);
      return {
        ...row,
        __status: error ? 'invalid' : 'pending',
        __error: error
      };
    });
  }
  // returns an error message, or '' if the row is fine. Also normalises the
  // paymentDate to DD-MM-YYYY on the row.
  validateRow(row) {
    var _row$transactionRefer, _row$paymentDate;
    if (!row.dealerId || isNaN(Number(row.dealerId))) {
      return 'dealerId is missing or invalid';
    }
    if (isNaN(Number(row.amount)) || Number(row.amount) <= 0) {
      return 'amount must be a positive number';
    }
    if (!PAYMENT_TYPES.includes(row.paymentType)) {
      return `paymentType must be one of: ${PAYMENT_TYPES.join(', ')}`;
    }
    if (row.paymentType === 'Net Banking' && !NET_BANKING_MODES.includes(String(row.paymentMode).toUpperCase())) {
      return `paymentMode must be one of ${NET_BANKING_MODES.join(', ')} for Net Banking`;
    }
    if (!String((_row$transactionRefer = row.transactionReference) !== null && _row$transactionRefer !== void 0 ? _row$transactionRefer : '').trim()) {
      return 'transactionReference is required';
    }
    if (!row.createdBy || isNaN(Number(row.createdBy))) {
      return 'createdBy must be a valid admin id';
    }
    if (row.paymentDate instanceof Date) {
      return 'paymentDate is Excel date-formatted. Re-enter it as Text (DD/MM/YYYY)';
    }
    const match = String((_row$paymentDate = row.paymentDate) !== null && _row$paymentDate !== void 0 ? _row$paymentDate : '').trim().match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (!match) return 'paymentDate must be DD/MM/YYYY';
    const [day, month, year] = [+match[1], +match[2], +match[3]];
    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 2000) {
      return 'paymentDate is not a valid DD/MM/YYYY date';
    }
    row.paymentDate = `${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}-${year}`;
    return '';
  }
  async uploadOne(row) {
    if (!this.canUpload(row)) return false;
    _vuePropertyDecorator.Vue.set(row, '__status', 'uploading');
    _vuePropertyDecorator.Vue.set(row, '__error', '');
    try {
      const {
        __status,
        __error,
        ...clean
      } = row;
      await (0, _ledgers.bulkUploadPayment)({
        data: [clean]
      });
      _vuePropertyDecorator.Vue.set(row, '__status', 'success');
      if (!this.uploadingAll && this.successCount === this.rows.length) {
        this.$message.success('All payments uploaded successfully!');
        this.handleClose();
      }
      return true;
    } catch (error) {
      _vuePropertyDecorator.Vue.set(row, '__status', 'error');
      _vuePropertyDecorator.Vue.set(row, '__error', (error === null || error === void 0 ? void 0 : error.message) || 'Upload failed');
      return false;
    }
  }
  async uploadAll() {
    try {
      await this.$confirm(`${this.uploadableRows.length} payment(s) will be added as pending payments. Proceed?`, 'Confirm Upload', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
    } catch {
      return;
    }
    this.uploadingAll = true;
    // one row per request, in order, to keep server load predictable
    for (const row of this.uploadableRows) {
      await this.uploadOne(row);
    }
    this.uploadingAll = false;
    if (this.failedCount) {
      this.$message.error('Some rows failed. See the Status column.');
    } else {
      this.$message.success('All payments uploaded successfully!');
      this.handleClose();
    }
  }
  reset() {
    this.rows = [];
  }
  handleClose() {
    if (this.uploadingAll) return;
    if (this.successCount) this.$emit('uploaded');
    this.reset();
    this.$emit('update:visible', false);
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "visible", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'BulkUploadPayment'
})], default_1);
var _default = exports.default = default_1;